export default "__VITE_ASSET__DYxTkskt__"